const slugify = (name: string) =>
	name
		.toLowerCase()
		.replace(/&/g, 'and') // convert ampersand to "and"
		.replace(/\s+/g, '-') // convert spaces to hyphens
		.replace(/[^a-z0-9-]/g, '') // remove invalid characters
		.replace(/-+/g, '-') // collapse multiple hyphens
		.replace(/^-+|-+$/g, '');

export { slugify };
